import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import SubMenu from "../../dashboard/components/side-nav-bar/sub-menus";
import MentoringMenuItems from "../../dashboard/components/side-nav-bar/sub-menus/containers/courses/containers/MentoringMenuItems";
import MentorProfiles from "./containers/mentor-profiles/MentorProfiles";
import MentorProfile from "./containers/mentor-profile-view/MentorProfile";
import CreateSession from "./containers/create-session-request/CreateSession";
import ViewMentoringSession from "./containers/view-mentoring-session/ViewMentoringSession";
import MentoringSessionRequests from "./containers/mentoring-session-requests/MentoringSessionRequests";
import MentorProfileCreate from "./containers/mentor-profile-create/MentorProfileCreate";
import {useAppUser} from "../../../contexts/user-context/UserContext";

export enum DashboardMentoringPages {
  MENTOR_PROFILES = "/dashboard/sessions/mentors",
  MENTOR_PROFILE = "/dashboard/sessions/mentors/:id",
  MENTORING_SESSIONS = "/dashboard/sessions/",
  CREATE_MENTORING_SESSION = "/dashboard/sessions/create",
  VIEW_MENTORING_SESSION = "/dashboard/sessions/session/:id",
  MENTORING_SESSION_REQUESTS = "/dashboard/sessions/requests",
  CREATE_MENTOR_PROFILE = "/dashboard/sessions/creatementorprofile",
}

const Mentoring = () => {
  const {fireUser, userRole} = useAppUser();

  return (
    <div className="dashboard-library-wrapper">
      <SubMenu>
        <MentoringMenuItems />
      </SubMenu>
      <Container fluid className="course-wrapper pt-0">
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route exact path={DashboardMentoringPages.MENTOR_PROFILES}>
                <MentorProfiles />
              </Route>
              <Route path={DashboardMentoringPages.MENTOR_PROFILE}>
                <MentorProfile />
              </Route>
              <Route
                exact
                path={DashboardMentoringPages.MENTORING_SESSIONS}
                component={() => {
                  return <MentoringSessionRequests />;
                }}
              />
              <Route
                exact
                path={DashboardMentoringPages.CREATE_MENTORING_SESSION}
                component={() => {
                  if (fireUser && userRole.isModerator) {
                    return <CreateSession />;
                  } else if (fireUser && !userRole.isModerator && userRole.isMember) {
                    return <MentoringSessionRequests />;
                  } else {
                    return <></>;
                  }
                }}
              />
              <Route path={DashboardMentoringPages.VIEW_MENTORING_SESSION}>
                <ViewMentoringSession />
              </Route>
              <Route
                path={DashboardMentoringPages.CREATE_MENTOR_PROFILE}
                component={() => {
                  if (fireUser && userRole.isAdmin) {
                    return <MentorProfileCreate />;
                  } else if (fireUser && !userRole.isAdmin && userRole.isMember) {
                    return <MentorProfiles />;
                  } else {
                    return <></>;
                  }
                }}
              />
              <Route
                exact
                path={DashboardMentoringPages.MENTORING_SESSION_REQUESTS}
                component={() => {
                  return <MentoringSessionRequests />;
                }}
              />
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{ borderLeft: "solid 1px #333" }} />
        </Row>
      </Container>
    </div>
  );
};

export default Mentoring;
